import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
} from "@mui/material";
import OtpInput from "react-otp-input";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Otp_url, Reotp_url } from "../../api/urls"; 
import { api } from "../../api/api";
import { useDispatch } from "react-redux";
import { logoutUser, setAccessToken } from "../../Redux/Auth";
import { useNavigate } from "react-router-dom";

const ProfileOtp = ({ mobile, otpToken, countryCode, onClose, setPage }) => {
  const { handleSubmit } = useForm();
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(30); 
  const [isResending, setIsResending] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleVerify = async () => {
    if (otp.length < 6) {
      setOtp("");
      toast.error("please enter a valid 6-digit OTP");
      return;
    }

    setLoading(true);

    try {
      await api.post(
        Otp_url,
        {
          recipient_otp: otp,
          mobile_flag: true,
        },
        {
          headers: {
            token: otpToken,
          },
        }
      );

      toast.success("OTP Verified!...Logging you out");
      dispatch(setAccessToken(otpToken));

      await dispatch(logoutUser());

      localStorage.removeItem("persist:root");
      localStorage.clear();

      navigate("/");
    } catch (error) {
      toast.error("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setIsResending(true);

      await api.post(Reotp_url, {
        mobile_number: `${countryCode}${mobile}`,
      });

      toast.success("OTP resent successfully!");
      setOtp("");
      setResendTimer(30);
    } catch (error) {
      toast.error("Failed to resend OTP");
    } finally {
      setIsResending(false);
    }
  };

  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  return (
    // <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
//     <Dialog
//   open
//   onClose={onClose}
//   fullWidth
//   maxWidth={false} // disable built-in size limits
//   sx={{
//     "& .MuiDialog-paper": {
//       width: "500px",     
//       height: "350px",     
//       borderRadius: "5px", 
//       padding: "20px",
//     },
//   }}
// >
<Dialog
  open
  onClose={onClose}
  fullWidth
  maxWidth={false}
  sx={{
    "& .MuiDialog-container": {
      display: "flex",
      alignItems: "center", // center vertically
      justifyContent: "center",
    },
    "& .MuiDialog-paper": {
      width: "500px",   // fixed width
      borderRadius: "12px",
      padding: "20px",
    },
  }}
>
  <DialogTitle
    sx={{ textAlign: "center", fontWeight: 600, fontSize: "22px" }}
  >
    Enter Otp
        </DialogTitle>

        <DialogContent>
          <Box textAlign="center">
            <Typography variant="body2" mb={2}>
              Enter OTP sent to +{countryCode} {mobile}
            </Typography>
            <OtpInput
              value={otp}
              onChange={setOtp}
              inputType="tel"
              shouldAutoFocus
        numInputs={6}
              renderSeparator={<span></span>}
              renderInput={(props) => <input {...props} />}
              inputStyle={{
          width: "50px",
          height: "50px",
          margin: "0 6px",
          fontSize: "18px",
          borderRadius: "8px",
                border: "1px solid #ccc",
          textAlign: "center",
          backgroundColor: "#fff",
              }}
            />

      {/* Content wrapper with fixed width to align resend + button */}
      <Box width="100%" maxWidth="350px">
        {/* Resend OTP - right aligned */}
        <Box mt={2} textAlign="right">
          <Typography
            component="span"
            fontSize="13px"
            sx={{
              color: resendTimer === 0 ? "black" : "grey",
              cursor: resendTimer === 0 ? "pointer" : "not-allowed",
            }}
            onClick={resendTimer === 0 ? handleResendOtp : null}
          >
            {isResending
              ? "Resending..."
              : resendTimer > 0
              ? `Resend in ${resendTimer}s`
              : "Resend otp"}
          </Typography>
        </Box>

        {/* Submit Button - same width as OTP & aligned */}
            <Button
              onClick={handleVerify}
              variant="contained"
          fullWidth
          sx={{
            mt: 3,
            bgcolor: "#000",
            color: "#fff",
            py: 1.5,
            borderRadius: "6px",
            fontSize: "14px",
            textTransform: "none",
            "&:hover": { bgcolor: "#000" },
          }}
              disabled={loading}
            >
          {loading ? "Submitting..." : "Submit"}
            </Button>
      </Box>
          </Box>
        </DialogContent>
    </Dialog>

  );
};

export default ProfileOtp;
